module.exports = __webpack_public_path__ + "e1ff725498daedc11be4cfb5b919c348.woff2";